import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';
import { Text } from '~/components/typography';

export const MessageWrapper = styled.div`
  background-color: rgba(183, 237, 237, 0.5);
  border-radius: 8px;
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  margin-bottom: 32px;
`;

export const VirginiaText = styled(Text).attrs({ color: 'primary' })<SpaceProps>`
  ${space}
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;
